"use client";

export default function PrivacySettingsButton({
  className = "text-sm hover:text-paper transition-colors",
}: {
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={() => {
        const w = window as unknown as {
          CookieConsent?: { renew?: () => void };
          Cookiebot?: { renew?: () => void };
        };
        const renew = () => {
          if (w.CookieConsent?.renew) w.CookieConsent.renew();
          else if (w.Cookiebot?.renew) w.Cookiebot.renew();
          else return false;
          return true;
        };
        // Cookiebot comes in via GTM, which is deferred until the first
        // interaction (app/layout.tsx) – if it's still loading, open the
        // dialog as soon as it's ready.
        if (!renew()) window.addEventListener("CookiebotOnLoad", renew, { once: true });
      }}
      className={`cursor-pointer border-0 bg-transparent p-0 text-left ${className}`}
    >
      Cookie-Einstellungen
    </button>
  );
}
